/* global G */
import { show, hide } from 'lib/sequence/component/state/hidden'
import listNoteTypes from 'app/_shared/events/collection/listNoteTypes'
import { isComplexTimeTrackingVisible } from 'app/ticket/hook/note'

/**
 * Returns the note type denoted by `type` or the current
 * action name.
 *
 * @param {Gaia.AppModule.Spec} module the current module composition object
 * @param {?string} [type=null]        an optional type
 * @returns {Promise<Object[]>}
 */
const _getNodeType = async (module, type = null) => {
  const action = module[G.STATE][G.ACTION]
  const actionComponent = action[G.COMPONENT]

  const [noteType] = await listNoteTypes(
    module,
    actionComponent,
    { detail: { key: type || action._name } },
  )

  return noteType
}

/**
 * Displays the `spentTime` field depending on the note type of the current
 * (quick) action.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*, ...[*]): Promise<*>}
 */
export default module => async (components, ...args) => {
  const action = module[G.STATE][G.ACTION]
  const actionComponent = action[G.COMPONENT]

  const { spentTime } = components

  const isTimeTrackingEnabled = action._name === 'close'
    ? isComplexTimeTrackingVisible(module, _getNodeType(module, 'close_resolved'))
      || isComplexTimeTrackingVisible(module, _getNodeType(module, 'close_cancel'))
    : isComplexTimeTrackingVisible(module, await _getNodeType(module))

  isTimeTrackingEnabled
    ? show(spentTime)
    : hide(spentTime)

  return [components, ...args]
}
